import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './extensions/login/login.component';
import { Authguard } from './modules/shared/interceptors/authguard.service';
import { ResetPasswordComponent } from './extensions/reset-password/reset-password.component';
import { AwsRedirectionComponent } from './extensions/aws-redirection/aws-redirection.component';
import { AwsRedirectionFailedComponent } from './extensions/aws-redirection-failed/aws-redirection-failed.component';
import { SignUpComponent } from './extensions/sign-up/sign-up.component';
import { ONBOARDING_METHODS } from './modules/shared/constants/api-constants';
import { EventsSignUpComponent } from './extensions/events-sign-up/events-sign-up.component';
import { SocialMediaSignUpComponent } from './extensions/social-media-sign-up/social-media-sign-up.component';
import { WhatsappSignUpComponent } from './extensions/whatsapp-sign-up/whatsapp-sign-up.component';
import { QuoteDocumentViewerComponent } from './extensions/document-viewer/quote-document-viewer/quote-document-viewer.component';
import { VoucherDocumentViewerComponent } from './extensions/document-viewer/voucher-document-viewer/voucher-document-viewer.component';
import { LandingLeadPageComponent } from './extensions/landing-lead-page/landing-lead-page.component';
import { InvoiceDocumentViewerComponent } from './extensions/document-viewer/invoice-document-viewer/invoice-document-viewer.component';
import { VisaDocumentsCollectionFormComponent } from './extensions/visa-documents-collection-form/visa-documents-collection-form.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/master-layout/master-layout.module').then(m => m.MasterLayoutModule),
    canActivateChild: [Authguard]
  },
  { path: 'login', component: LoginComponent },
  { path: 'sign-up', component: SignUpComponent, data: { onboardingMethod: ONBOARDING_METHODS.Website } },
  { path: 'events', component: EventsSignUpComponent, data: { onboardingMethod: ONBOARDING_METHODS.Events } },
  { path: 'social', component: SocialMediaSignUpComponent, data: { onboardingMethod: ONBOARDING_METHODS.Social } },
  { path: 'whatsapp', component: WhatsappSignUpComponent, data: { onboardingMethod: ONBOARDING_METHODS.WhatsApp } },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'verify', component: AwsRedirectionComponent },
  { path: 'verification-failed', component: AwsRedirectionFailedComponent },
  { path: 'qr/:code', component: QuoteDocumentViewerComponent }, // public quote viewer
  { path: 'vo/:code', component: VoucherDocumentViewerComponent }, // public Voucher viewer
  { path: 'in/:code', component: InvoiceDocumentViewerComponent }, // public Invoice viewer
  { path: 'la/:code', component: LandingLeadPageComponent }, // public Lead form
  { path: 'vi/:code', component: VisaDocumentsCollectionFormComponent }, // public Visa Document collection form
  { path: '**', redirectTo: '' },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
